import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import mobile from "../../assests/img/Asset 24.png";
import email from "../../assests/img/Asset 23.png";
import logo from "../../assests/img/kior logo.svg";
import nabhlogo from "../../assests/img/nabhlogo.png";

const Header = () => {
  return (
    <div className="navbar_inner">
      <div className="header_top">
        <div className="coustom_container">
          <div className="header_top_left">
            <div>
              <Link to="/">
                <img src={logo} alt="logo" className="logo" />
              </Link>
              <img src={nabhlogo} alt="nabhlogo" className="logo nabh-logo" />
            </div>

            <div className="header_top_right_text">
              <Link to="contact-us" className="me-3">
                Contact Us
              </Link>
              <span className="me-3">
                <img src={mobile} alt="mobile-img" />
                +91 8263000004,+91 9875964159
              </span>
              <span className="me-3">
                <img src={email} alt="email-img" className="email_img" />{" "}
                kiorhealthcare8b@gmail.com
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="header_bottom_sec">
        <div className="coustom_container">
          <div className="header_bottom">
            <Navbar expand="lg" className="bg-body-tertiary">
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link href="about-us">ABOUT US</Nav.Link>
                  <Nav.Link href="package">PACKAGES</Nav.Link>
                  <Nav.Link href="contact-us">CONTACT US</Nav.Link>
                  <Nav.Link href="faq">FAQ</Nav.Link>
                  <Nav.Link href="feedback">FEEDBACK</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
